import React from 'react'
import Helmet from 'react-helmet'
import config from '../utils/siteConfig'
import '../templates/base.scss'
import Layout from '../components/Layout/Layout'
import SEO from '../components/SEO'
import ITOpsContent from '../components/ITOps/ITOpsContent/ITOpsContent'
import ITOpsHero from '../components/ITOps/ITOpsHero/ITOpsHero'

const ITOperations = ({ data }) => {
  const postNode = {
    title: `IT Operations - ${config.siteTitle}`,
  }

  return (
    <Layout>
      <SEO postNode={postNode} pagePath="it-operations" customTitle />
      <Helmet>
        <title>{`IT Operations - ${config.siteTitle}`}</title>
      </Helmet>
      <ITOpsHero />
      <ITOpsContent />
    </Layout>
  )
}

export default ITOperations
